import React, { useCallback } from 'react';
import { Card } from 'react-bootstrap';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridCountFunction,
  GridGetterFunction,
  GridRecord,
} from '../../../common/components/Grid/GridDataTypes';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import momencik from '../../../common/momencik';
import { GetPrinterJpkDocumentDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { PrinterJpkDocumentPreviewLink } from '../../components/PrinterJpkDocument/PrinterJpkDocumentPreviewLink';

const docForGrid = (doc: GetPrinterJpkDocumentDto): GridRecord => ({
  key: doc.id,
  values: {
    'document.jpkId': doc.jpkId ?? '',
    'document.printerUid': doc.printerUid ?? '',
    'document.documentType': doc.documentType ?? '',
    'document.documentTs': momencik(doc.documentTs, 'YYYY-MM-DD HH:mm:ss'),
    'document.actions': (
      <PrinterJpkDocumentPreviewLink printerJpkDocumentId={doc.id} />
    ),
  },
});

const columns = [
  { header: 'JPK ID', property: 'document.jpkId' },
  { header: 'UID drukarki', property: 'document.printerUid' },
  { header: 'Typ dokumentu', property: 'document.documentType' },
  { header: 'Data dokumentu', property: 'document.documentTs' },
  { header: '', property: 'document.actions', noSorting: true, noFilter: true },
];

export const PrinterJpkDocumentView: React.FC = () => {
  const spd = useSpdCore();

  const getData: GridGetterFunction = useCallback(
    async (
      pageSize,
      pageNumber,
      orderBy,
      orderDirection,
      filterText,
      filterColumns,
    ) => {
      const docs = await spd.printerJpkDocuments.getAllByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
      );
      return docs.map(docForGrid);
    },
    [spd.printerJpkDocuments],
  );

  const getCount: GridCountFunction = useCallback(
    (filterText, filterColumns) =>
      spd.printerJpkDocuments.getAllCount(filterText, filterColumns),
    [spd.printerJpkDocuments],
  );

  return (
    <Card>
      <Card.Header>Drukarki - dokumenty JPK</Card.Header>
      <Card.Body>
        <Grid
          getData={getData}
          getDataCount={getCount}
          columns={columns}
          showFilter={true}
          withFilterInColumns={true}
          initialOrderDirection="DESC"
          initialOrderColumn="document.documentTs"
          availablePageSizes={[10, 20, 50]}
          emptyGridMessage="Brak dokumentów JPK w systemie"
        />
      </Card.Body>
    </Card>
  );
};
